import { Paper, Typography, Icon, IPaper } from '@sanlam-glacier/app-common/components';
import { PropsWithChildren, ReactNode } from 'react';
import './hintbox.style.scss';
import { Block } from '@sanlam-glacier/app-common/modules/grid';

interface HintBoxProps {
  header?: ReactNode;
  backgroundColour?: IPaper['color'];
  hideIcon?: boolean;
  icon?: string;
}

export const HintBox = ({
  header,
  backgroundColour,
  hideIcon = false,
  icon,
  children
}: PropsWithChildren<HintBoxProps>) => {
  return (
    <Block sm={12}>
      <Paper
        color={backgroundColour ?? Paper.COLOR.QUATERNARY}
        rounding={Paper.ROUNDING.SMALL}
        variant={Paper.VARIANT.DEFAULT}
        className='hintbox-container'
      >
        {!hideIcon && (
          <div className='hintbox-icon'>
            <Typography variant={Typography.VARIANT.H3} color={Typography.COLOR.PRIMARY}>
              <Icon icon={icon ? icon : 'action_lightbulb-outline'} />
            </Typography>
          </div>
        )}
        <div className='hintbox-content'>
          {header && (
            <Typography variant={Typography.VARIANT.B2} className='hintbox-header-padding'>
              <strong>{header}</strong>
            </Typography>
          )}
          {children && <div>{children}</div>}
        </div>
      </Paper>
    </Block>
  );
};
